/** Pause every HTML media element owned by a hidden UI subtree. */
export function pauseMediaElements(root: ParentNode | null): void {
  root
    ?.querySelectorAll<HTMLMediaElement>('video, audio')
    .forEach((media) => media.pause());
}
